import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui';
import { DesignerState } from './DesignerFlow';
interface Props {
  data: DesignerState;
  updateData: (data: Partial<DesignerState>) => void;
  onNext: () => void;
}
export function Step1Basics({
  data,
  updateData,
  onNext
}: Props) {
  const eventTypes = ['Corporate Offsite', 'Leadership Retreat', 'Sales Kickoff', 'Training Day', 'Wellness Retreat', 'Association Meeting', 'Incentive Trip', 'Client Event', 'Other'];
  const locationTypes = ['Hotel', 'Resort', 'Conference Centre', 'Office', 'Destination Venue', 'Hybrid'];
  const lengths = ['Half-day', 'Full-day', '2 days', '3 days', '4+ days'];
  const isValid = data.eventName && data.eventType && data.locationType && data.location && data.attendees && data.length;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12" data-id="element-2475">
      <h1 className="text-3xl font-bold text-brand-navy mb-8" data-id="element-2476">
        Tell us about your offsite.
      </h1>

      <div className="space-y-6" data-id="element-2477">
        <div data-id="element-2478">
          <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2479">
            Event name
          </label>
          <input type="text" value={data.eventName} onChange={e => updateData({
          eventName: e.target.value
        })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" placeholder="e.g. Q3 Leadership Reset" data-id="element-2480" />
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-2481">
          <div data-id="element-2482">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2483">
              Event type
            </label>
            <select value={data.eventType} onChange={e => updateData({
            eventType: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all bg-white" data-id="element-2484">
              <option value="" disabled data-id="element-2485">
                Select type...
              </option>
              {eventTypes.map(t => <option key={t} value={t} data-id="element-2486">
                  {t}
                </option>)}
            </select>
          </div>
          <div data-id="element-2487">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2488">
              Location type
            </label>
            <select value={data.locationType} onChange={e => updateData({
            locationType: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all bg-white" data-id="element-2489">
              <option value="" disabled data-id="element-2490">
                Select location type...
              </option>
              {locationTypes.map(t => <option key={t} value={t} data-id="element-2491">
                  {t}
                </option>)}
            </select>
          </div>
        </div>

        <div data-id="element-2492">
          <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2493">
            Location / destination
          </label>
          <input type="text" value={data.location} onChange={e => updateData({
          location: e.target.value
        })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" placeholder="e.g. Austin, TX or The Ritz-Carlton" data-id="element-2494" />
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-2495">
          <div data-id="element-2496">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2497">
              Attendees
            </label>
            <input type="number" value={data.attendees} onChange={e => updateData({
            attendees: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" placeholder="e.g. 50" data-id="element-2498" />
          </div>
          <div data-id="element-2499">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2500">
              Event length
            </label>
            <select value={data.length} onChange={e => updateData({
            length: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all bg-white" data-id="element-2501">
              <option value="" disabled data-id="element-2502">
                Select length...
              </option>
              {lengths.map(t => <option key={t} value={t} data-id="element-2503">
                  {t}
                </option>)}
            </select>
          </div>
          <div data-id="element-2504">
            <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-2505">
              Event date
            </label>
            <input type="date" value={data.date} onChange={e => updateData({
            date: e.target.value
          })} className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-teal focus:border-brand-teal outline-none transition-all" data-id="element-2506" />
          </div>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-slate-100 flex justify-end" data-id="element-2507">
        <Button variant="primary" size="lg" onClick={onNext} disabled={!isValid} data-id="element-2508">
          Continue
        </Button>
      </div>
    </motion.div>;
}